import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import InputField from './InputField';
import Button from './button';
import Heading from './heading';
import ChangePassword from './changePassword';
import { getOtp } from './../../../actions/userActions';
import {
    EmailOrMobileValidation
} from './../../../library/validation';
import APP from 'app';
const { defaultRole = '' } = APP.Utils.getConfig();
const { Utils } = APP, { translateText } = Utils;

class ForgetPassword extends Component {
    state = {
        showOtp: false,
        otpJson: {
            userName: '',
            role: defaultRole
        },
        error: false,
        userErr: ''
    }

    onChangeHandler = (value, context) => {
        this.setState({
            otpJson: {
                ...this.state.otpJson,
                [context]: value
            }
        })
    }

    onSubmitHandler = () => {
        const validateStatus = this.validate();
        const { otpJson = {} } = this.state;
        if (validateStatus) {
            this.props.dispatch(getOtp(otpJson));
            this.setState({
                showOtp: !this.state.showOtp
            })
        } else {
            this.setState({
                errMsg: true
            });
        }
    }

    validate = () => {
        const { otpJson = {} } = this.state;
        const { userName } = otpJson;
        let isValid = EmailOrMobileValidation(userName);
        if (isValid != true) {
            const { errMsg = {} } = isValid;
            this.setState({
                userErr: errMsg
            });
            return false;
        } else {
            this.setState({
                userErr: ''
            });
        }
        return true;
    }

    onKeyDown(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            this.onSubmitHandler();
        }
    }

    onBlur = () => {
        if (this.state.errMsg) {
            this.validate();
        }
    }

    setErrMsg = (userDataErrors) => {
        this.setState((prevState) =>
        ({
            userData: {
                ...prevState.userData,
                ...userDataErrors
            }
        })
        )
    }

    openSignHandler = () => {
        if (typeof this.props.showForgetHandler === 'function') {
            this.props.showForgetHandler();
        }
    }

    render() {
        const { showOtp = false, otpJson = {}, userErr = '' } = this.state;
        return (
            <Fragment>
                {!showOtp ?
                    <Fragment>
                        <Heading
                            title={translateText('forgotPassword', 'B2CLogin')}
                        />
                        <InputField
                            type='text'
                            placeholder={translateText('emailOrMobile', 'B2CLogin')}
                            context='userName'
                            onChangeHandler={this.onChangeHandler}
                            name='emailorAddress'
                            value={otpJson['userName']}
                            handleKeyDown={this.onKeyDown}
                            onBlur={this.onBlur}
                            errorText={userErr}
                        />
                        <Button
                            type='button'
                            onSubmitHandler={this.onSubmitHandler}
                            displayLabel={translateText('submitBtn', 'B2CLogin')}
                        />
                        <p className="b2c__loginwrap--createAccount b2c__loginwrap--backtologin">
                            {translateText('alreadyHaveAnAccount', 'B2CLogin')}
                                <span
                                className="b2c__loginwrap--createlink"
                                onClick={this.openSignHandler}
                            >
                                {translateText('signIn', 'B2CLogin')}
                                </span>
                        </p>
                    </Fragment>
                    : <ChangePassword
                        showForgetHandler={this.props.showForgetHandler}
                    />
                }


            </Fragment>
        )
    }
}

const mapDispatchToProps = dispatch => {
    let actions = bindActionCreators({
        getOtp
    });
    return { actions, dispatch };
};

export default connect(null, mapDispatchToProps)(ForgetPassword);